export function formatScanSource({ chatType, groupName, addedBy, addedByUserId } = {}) {
  if (addedByUserId === 'system' || (addedBy && String(addedBy).startsWith('WalletMonitor:'))) {
    return { label: '🤖 system', sub: addedBy || null };
  }
  if (chatType === 'private') {
    return { label: '👤 private', sub: addedBy || null };
  }
  if (groupName) {
    return { label: `👥 ${groupName}`, sub: addedBy || null };
  }
  return { label: '👥 Group', sub: addedBy || null };
}

export function formatScanSourceList(groupNameList) {
  if (!groupNameList?.length) return null;
  return groupNameList.join(', ');
}
